export { LucideIcon } from './LucideIcon'
export type { LucideIconProps, LucideIconName } from './LucideIcon'
